import { render, staticRenderFns } from "./SmListNotice.vue?vue&type=template&id=ae47296a&scoped=true&"
import script from "./SmListNotice.vue?vue&type=script&lang=ts&"
export * from "./SmListNotice.vue?vue&type=script&lang=ts&"
import style0 from "./SmListNotice.vue?vue&type=style&index=0&id=ae47296a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae47296a",
  null
  
)

export default component.exports